const config = require("../config")
const url = config.base_dev_url + "z_farm_work_order"

module.exports = {
    pesticideFertilizersList: {
        url: url + "/pesticideFertilizers",
        type: "get",
    },
}